import { Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AwarenessCampaignsMethods from '../../actions/awarenessCampaigns';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectFullyFilteredCampaigns } from '../../store/reducers/awareness_campaigns/filters';
import CampaignGrid from './FilterComponents/CampaignGrid';
import FiltersContainer from './FilterComponents/FiltersContainer';
import { usePartnerID } from '../../hooks/partners';

function AwarenessCampaignsPage() {
    const dispatch = useAppDispatch();
    const showAmbassadorCompleted = useAppSelector(state => state.awareness_campaign.list.showAmbassadorCompleted);
    const loading = useAppSelector(state => state.awareness_campaign.list.loading);
    const partnerID = usePartnerID();
    const email = useAppSelector((state) => state.user.email);
    
    // Get filtered campaigns using the new selector that applies all filters
    const finalFilteredMissions = useAppSelector(selectFullyFilteredCampaigns);

    useEffect(() => {
        if (partnerID && email) {
            dispatch(AwarenessCampaignsMethods.getAwarenessCampaigns(partnerID, email));
        }
    }, [dispatch, partnerID, email]);

    return (
        <Box display="flex" flexDirection="column" height="100vh" sx={{ overflowY: 'auto' }}>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" flexGrow={1}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {/* Filters Container */}
                    <FiltersContainer />
                    
                    {/* Campaign Grid */}
                    <CampaignGrid 
                        missions={finalFilteredMissions}
                        showAmbassadorCompleted={showAmbassadorCompleted}
                    />
                </>
            )}
            <Outlet />
        </Box>
    );
}

export default AwarenessCampaignsPage;
